<template>
    <div></div>
</template>

<script>
export default {
    name: 'DeleteAcademyProduct',
    props: {
        popupDeleteAcademy: {
            type: Boolean,
            default: false,
        },
        academyId: Number
    },

    watch: { 
      	popupDeleteAcademy: function(newVal) {
            if(newVal == true){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "حذف آکادمی",
                    text: `آکادمی حذف شود؟`,
                    acceptText: "حذف",
                    cancelText: "انصراف",
                    accept: this.deleteAcademy,
                    cancel: this.cancelDelete,
                })
            }            
        },
    },
    
    methods: {
        cancelDelete(){
            this.$emit('updatePopupDeleteAcademy', false)
        },

        deleteAcademy(){
            this.$vs.loading()
            this.$emit('updatePopupDeleteAcademy', false)
            let id = this.academyId
            let type = 'academy'
			this.$store.dispatch('deletePost', { id, type })
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'آکادمی با موفقیت حذف شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>